<template>
  <div class="top-bar">
    <div class="top-bar-left">
      <svg
        v-if="showBack"
        @click.stop="handleClick"
        register
        t="1747892392635"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="27855"
        width="25"
        height="25"
      >
        <path
          register
          d="M631.04 161.941333a42.666667 42.666667 0 0 1 63.061333 57.386667l-2.474666 2.730667-289.962667 292.245333 289.706667 287.402667a42.666667 42.666667 0 0 1 2.730666 57.6l-2.474666 2.752a42.666667 42.666667 0 0 1-57.6 2.709333l-2.752-2.474667-320-317.44a42.666667 42.666667 0 0 1-2.709334-57.6l2.474667-2.752 320-322.56z"
          p-id="27856"
        ></path>
      </svg>
    </div>
    <div class="top-bar-center" :style="{ flex: title.length > 10 ? 3 : 1 }">
      <div class="top-bar-center-text">{{ title }}</div>
    </div>
    <div class="top-bar-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script setup>
const router = useRouter()
const attrs = useAttrs()
const props = defineProps({
  showBack: {
    type: Boolean,
    default: true
  },
  title: {
    type: String,
    default: ''
  }
})
const emits = defineEmits(['back'])
const handleClick = (e) => {
  if (attrs.onClick) {
    // ✅ 如果父组件传了 @click，就触发它
    attrs.onClick(e)
  } else {
    // ✅ 否则执行默认逻辑
    router.back()
  }
}
if (window.__themeEnv === 'YT') {
  import(`@/assets/css/YT/topBar.css`)
} else if (window.__themeEnv === 'CICC') {
  import(`@/assets/css/CICC/topBar.css`)
} else if (window.__themeEnv === 'CMBIT') {
  import(`@/assets/css/CMBIT/topBar.css`)
} else if (window.__themeEnv === 'TKBIT') {
  import(`@/assets/css/TKBIT/topBar.css`)
} else if (window.__themeEnv === 'ARKADEX') {
  import(`@/assets/css/ARKADEX/topBar.css`)
} else if (window.__themeEnv === 'EXMINING') {
  import(`@/assets/css/EXMINING/topBar.css`)
}
</script>
